import logoWord from '../assets/logo-word.png'
import styled from '@emotion/styled'
import Plans from '../components/Plans'
import Cases from '../components/Cases'
import ContactUs from '../components/ContactUs'
import AboutUs from '../components/Aboutus'

const Container = styled.div`
  width: 79%;
  margin: 8em auto;
  text-align: center;
`
const Block = styled.div`
  margin: 8em auto;
`

export default function Home() {
  const blockList = [
    {
      id: 'plans',
      component: <Plans />,
    },
    {
      id: 'cases',
      component: <Cases />,
    },
    {
      id: 'aboutus',
      component: <AboutUs />,
    },
    {
      id: 'contactus',
      component: <ContactUs />,
    },
  ]

  return (
    <Container maxWidth="lg">
      <Block >
        <img src={logoWord} alt="行創有限公司" style={{ width: '100%' }} />
      </Block>
      {blockList.map((item, i) => (
        <Block key={i} id={item.id}>
          {item.component}
        </Block>
      ))}
    </Container>
  )
}
